import 'css-chunksrc/client/common/listSelect/list/styles.scss';export default {
  "heading": "_heading_go7x8_1",
  "iconBox": "_iconBox_go7x8_18",
  "icon": "_icon_go7x8_18",
  "openedIcon": "_openedIcon_go7x8_36",
  "empty": "_empty_go7x8_40",
  "selectedList": "_selectedList_go7x8_44",
  "folderIconBox": "_folderIconBox_go7x8_48",
  "folderIcon": "_folderIcon_go7x8_48"
};